
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    body: () => {
      return  {
        display: 'flex',
        width: '100%',
        height: 'calc(100% - 110px)',
        flexDirection: 'column !important',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
      };
    },

    /* guide.js  now needs a different styles for the body padding */
    guideBody: () => {
      return  {
        display: 'flex',
        flex: 1,
        minHeight: 0,
        width: '100%',
        flexDirection: 'column !important',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '0 48px',
        boxSizing: 'border-box',
        // Scrollbar Styling
        scrollbarGutter: 'stable',
        scrollbarWidth: '12px',
        scrollbarColor: 'transparent transparent',
        '&::-webkit-scrollbar': { width: '12px' },
        '&::-webkit-scrollbar-thumb': {
            background: 'transparent',
            borderRadius: '5px',
        },
        '&:hover::-webkit-scrollbar-thumb': {
            background: '#D9D9D9',
            backgroundColor: 'transparent',
        },
        '&:hover': {
          scrollbarColor: '#D9D9D9 transparent',
        },
      };
    },

    subtitle: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
      };
    },

    bodyMessages: () => {
      return  {
        display: 'flex',
        flexDirection: 'column !important',
        fontSize: '14px',
        width: '100%',
        fontWeight: 'regular',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '12px 0px',
        textAlign: 'center',
      };
    },

    guideContentBody: {
      display: 'flex',
      flex: 1,
      minHeight: 0,
      padding: '0 48px',
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      flexDirection: 'column !important',
      alignItems: 'center',
      boxSizing: 'border-box',
      // Scrollbar Styling
      scrollbarGutter: 'stable',
      scrollbarWidth: '12px',
      scrollbarColor: 'transparent transparent',
      '&::-webkit-scrollbar': { width: '12px' },
      '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
          borderRadius: '5px',
      },
      '&:hover::-webkit-scrollbar-thumb': {
          background: '#D9D9D9',
          backgroundColor: 'transparent',
      },
      '&:hover': {
        scrollbarColor: '#D9D9D9 transparent',
      },
    },

    guideContent: {
      display: 'flex',
      flexDirection: 'column !important',
      width: '100%',
      alignItems: 'center',
      marginTop: '8px',
    },

    copyLinkIcon: {
      backgroundColor: '#000082',
    },

    copyButtonOutlined: (p) => {
      const {
        commonUIStyles = {
          copyLinkButton: () => ({}),
        },
      } = p;

      const copyLinkStyles = commonUIStyles.copyLinkButton();
      const styles = {
        backgroundColor: 'transparent !important',
        border: 'none !important',
        color: '#000082 !important',
        fontWeight: '400',
        boxShadow: 'none',
      };

      return  {
        '&.MuiButton-root': {
          ...commonUIStyles.copyLinkButton(),
          ...styles,
          '&[disabled]': {
            ...styles,
          },
        },
      };
    },

    copyButtonSolid: (p) => {
      const {
        commonUIStyles = {
          copyLinkButton: () => ({}),
        },
      } = p;

      const copyLinkStyles = commonUIStyles.copyLinkButton();
      const styles = {
        backgroundColor: '#000082 !important',
        color: '#FFFFFF !important',
        border: 'none',
        borderRadius: '0 !important',
        height: '100%',
        fontWeight: 'bold !important',
      };

      return  {
        '&.MuiButton-root': {
          ...copyLinkStyles,
          ...styles,
          '&[disabled]': {
            ...styles,
          },
        },
      };
    },

    nextButton: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      alignItems: 'center',
      marginTop: '6px',
      height: '50px',
      flexDirection: 'column !important',
      flexShrink: 0,
    },
    
    progress: (p) => {
      const {
        commonUIStyles = {
          button: () => ({}),
        },
      } = p;

      return {
        color: `${commonUIStyles.foreColor()} !important`,
      };
    },

    copythislink: {
    
    },

    linkSpace: {
      display: 'flex',
      width: '100%',
      flexShrink: 0,
      height: '52px',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid #DEDDDF',
      borderRadius: '8px',
      overflow: 'hidden',
      padding: '0px 0px 0px 10px',
      boxSizing: 'border-box',
    },

    linkDivider: {
      width: '1px',
      alignSelf: 'stretch',
      backgroundColor: '#DEDDDF',
      flexShrink: 0,
    },

    webcalPrefix: {
      fontFamily: 'monospace',
      fontSize: '11px',
      fontWeight: 600,
      color: '#1a48b8',
      backgroundColor: '#e8f0fe',
      padding: '2px 4px',
      borderRadius: '3px',
      flexShrink: 0,
      lineHeight: '1.5',
      marginRight: '2px',
    },

    link: ({ commonUIStyles }) => {
      return {
        ...commonUIStyles.textLink(),
        color: '#1a1a1a',
        fontSize: '11px',
        fontWeight: 400,
        lineHeight: '1.5',
        display: 'block',
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textTransform: 'none',
      };
    },

    copyButtonBase: {
      '&.MuiButtonBase-root': {
        whiteSpace: 'nowrap',
        flex: '0 0 auto',
        height: '100%',
        padding: '0 8px',
        borderRadius: 0,
      }
    },

    help: {
      marginTop: '12px',
      marginBottom: '13px',
      display: 'flex',
      flexDirection: 'row',
      width: 'calc(100% - 64px)',
      justifyContent: 'center',
      flexShrink: 0, // <--- Prevents the help text from squishing
    },

    banner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    bannerImage: {
      width: '100%',

      '&[data-platform="windows_ie"]': {
        width: '100%',
      },
    },

    spinnerBox: {
      display: 'flex',
      width: '70%',
    },

    code: {
      backgroundColor: '#f0f0f0',
      marginLeft: '6px',
      marginRight: '6px',
    },

    warning: {
      width: '20px',
      height: '20px',
      marginRight: '4px',
      marginTop: '-5px',
    },

    flowText: () => {
      return  {
        display: 'flex',
        flexDirection: 'row !important',
        fontSize: '14px',
        width: '100%',
        fontWeight: 'regular',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '12px 0px',
        textAlign: 'center',
      };
    },

    stepsList: () => {
      return {
        display: 'flex',
        flexDirection: 'column !important',
        width: '98%',
        marginTop: '8px',
      };
    },

    instructionSubTitle: () => {
      return {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontSize: '18px',
        fontWeight: 500,
        marginBottom: '16px',
        padding: '0px 24px',
      };
    },

    stepRow: () => {
      return {
        display: 'flex',
        flexDirection: 'row !important',
        alignItems: 'flex-start',
        width: '100%',
        marginBottom: '12px',
        textAlign: 'left',
        overflow: 'hidden',
      };
    },

    stepRowSmallMargin: {
      marginBottom: '4px !important',
    },

    stepRowStep5Margin: {
      marginBottom: '8px !important',
    },

    stepNumber: () => {
      return {
        fontWeight: 'bold',
        display: 'flex',
        fontSize: '14px',
        minHeight: '26px',
        marginRight: '8px',
        
        minWidth: '10px', // Prevents the text from shifting if numbers get wider
      };
    },

    stepNumberCenter: {
      alignItems: 'center',
    },

    stepText: () => {
      return {
        fontSize: '14px',
        lineHeight: '1.4',
        fontWeight: 'regular',
        color: '#333333',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap', // Allows icons to wrap with text if needed
      };
    },

    stepBadge: {
      width: '22px',
      height: '22px',
      minWidth: '22px',
      borderRadius: '50%',
      backgroundColor: '#f1f3f5',
      color: '#1a1a1a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: 700,
      flexShrink: 0,
      marginRight: '10px',
      marginTop: '2px',
    },

    stepContent: {
      display: 'flex',
      flexDirection: 'column !important',
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
    },

    stepLabel: {
      fontSize: '14px',
      fontWeight: 600,
      color: '#333333',
      marginBottom: '6px',
    },

    stepDescription: {
      fontSize: '13px',
      color: '#555555',
      lineHeight: '1.5',
      display: 'block',
    },

    webcalWarning: {
      color: '#D32F2F',
      fontWeight: 600,
    },
});

export default styles;
export const useStyles = makeStyles(styles);
